export const Questionmark = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clip-path='url(#clip0_16807_27812)'>
      <path
        d='M7.9987 14.6667C11.6806 14.6667 14.6654 11.6819 14.6654 8.00004C14.6654 4.31814 11.6806 1.33337 7.9987 1.33337C4.3168 1.33337 1.33203 4.31814 1.33203 8.00004C1.33203 11.6819 4.3168 14.6667 7.9987 14.6667Z'
        stroke='#001A3D'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M6.05859 6.00001C6.21533 5.55446 6.5247 5.17875 6.9319 4.93944C7.3391 4.70012 7.81786 4.61264 8.28338 4.69249C8.7489 4.77234 9.17114 5.01436 9.47531 5.3757C9.77949 5.73703 9.94596 6.19436 9.94526 6.66668C9.94526 8.00001 7.94526 8.66668 7.94526 8.66668'
        stroke='#001A3D'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M8 11.3334H8.00667'
        stroke='#001A3D'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </g>
    <defs>
      <clipPath id='clip0_16807_27812'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </svg>
)
